module.exports = __webpack_public_path__ + "img/475.b7fa6b63.jpg";